RivalIQ.apps.Favorites.module('data.metrics', function (metrics, App, Backbone, Marionette, $, _) {

    'use strict';

    const requirementType = {
        PLAN: 1,
        TOKEN: 2
    };

    function getRestrictionType(metric, props) {
        if (!RivalIQ.metric.access.plan(metric, props.plan)) {
            return requirementType.PLAN;
        }

        if (!RivalIQ.metric.access.token(metric, props)) {
            return requirementType.TOKEN;
        }
    }

    function getDescription(metric, type, objectName) {
        if (type === requirementType.PLAN) {
            return {
                title: undefined,
                description: RivalIQ.str('plan_requirement_desc', objectName)
            };
        } else if (type === requirementType.TOKEN) {
            return {
                title: undefined,
                description: RivalIQ.str('token_requirement_desc', objectName)
            };
        }

        return {
            title: RivalIQ.metric.names.metricName(metric),
            description: RivalIQ.metric.search.getPropertyValue(metric, 'description')
        };
    }

    // TODO cache between requests?
    metrics.getMetricSelectOptions = function (dashboardModel, source, props, baseMetric, additionalMetrics) {

        let metrics;
        const objectType = _.get(baseMetric, 'objectType');
        const sourceIsInstaInsights = (source === RivalIQ.enums.sources.INSTAGRAM_INSIGHTS);
        const isPostMetric = ((objectType === RivalIQ.enums.insightsObjectType.post) || RivalIQ.metric.hasDimension(baseMetric, RivalIQ.enums.insightsObjectType.post));
        const sourceIsInsights = _.includes([RivalIQ.enums.sources.INSTAGRAM_INSIGHTS, RivalIQ.enums.sources.LINKEDIN, RivalIQ.enums.sources.FACEBOOK_INSIGHTS, RivalIQ.enums.sources.TWITTER_INSIGHTS, RivalIQ.enums.sources.TIKTOK_INSIGHTS], source);

        if (RivalIQ.metric.hasDimension(baseMetric, RivalIQ.enums.insightsObjectType.post)) {
            metrics = RivalIQ.data.metrics.forSourcePost(source, {
                hasPaidEngagement: RivalIQ.apps.Insights.utils.hasInstagramPaidEngagement(dashboardModel)
            });
        } else if (RivalIQ.metric.hasDimension(baseMetric, RivalIQ.enums.insightsObjectType.story)) {
            metrics = RivalIQ.data.metrics.forSourceStory(source);
        } else if (RivalIQ.metric.hasDimension(baseMetric, RivalIQ.enums.insightsObjectType.storyDay)) {
            metrics = RivalIQ.data.metrics.forSourceStoryDay(source);
        } else if (sourceIsInstaInsights && (objectType === RivalIQ.enums.insightsObjectType.post)) {
            metrics = RivalIQ.data.metrics.forSourcePostAggregates(source, {
                hasPaidEngagement: RivalIQ.apps.Insights.utils.hasInstagramPaidEngagement(dashboardModel)
            });
        } else if (sourceIsInstaInsights && (objectType === RivalIQ.enums.insightsObjectType.story)) {
            metrics = RivalIQ.data.metrics.forSourceStoryAggregates(source);
        } else if (sourceIsInsights && isPostMetric && Boolean(baseMetric.analysisProperty)) {
            metrics = RivalIQ.data.metrics.forSourcePostAggregates(source);
        } else {
            metrics = RivalIQ.data.metrics.forSource(source);
        }

        metrics = _.union(metrics, additionalMetrics);

        let sortedMetrics = metrics;
        if (!sourceIsInstaInsights || !isPostMetric) {
            // if not insta insights, order index by name
            const metricList = _.map(metrics, function (metric) {
                const sourceMetric = RivalIQ.metric.build(metric, _.defaults({
                    channel: RivalIQ.data.channels.get(source).getChannel()
                }, baseMetric), {
                    prependDimensions: true
                });

                return _.defaults(metric, {
                    name: RivalIQ.metric.names.metricName(sourceMetric)
                });
            });

            const sortedByName = _.sortBy(metricList, 'name');
            sortedMetrics = _.map(sortedByName, function (metric) {
                return _.omit(metric, 'name');
            });
        }

        const betaFeatures = RivalIQ.state.account.get('betaFeatures');

        // NOTE filter out metrics tied to betas, as, unlike say plan restrictions, we don't want to advertise their availability
        // It's important to filter before mapping to make sure we don't skip any indexes. See #33359
        // BUGBUG as a short term hack for #33730, also filter out based on plan restrictions; remove this once estimated impressions goes to full launch!
        const accessibleMetrics = _.filter(sortedMetrics, sourceMetric => RivalIQ.metric.access.beta(sourceMetric, betaFeatures) && RivalIQ.metric.access.plan(sourceMetric, props.plan));

        const metricMap = _.map(accessibleMetrics, function (metric, i) {
            const sourceMetric = RivalIQ.metric.build(metric, _.defaults({
                channel: RivalIQ.data.channels.get(source).getChannel()
            }, baseMetric), {
                prependDimensions: true
            });

            const restriction = getRestrictionType(sourceMetric, props);
            const disabled = Boolean(restriction);
            const description = getDescription(sourceMetric, restriction, 'metric');

            return {
                index: i,
                name: RivalIQ.metric.names.metricName(sourceMetric),
                description: description,
                disabled: disabled,
                selectable: _.isUndefined(metric.selectable) || Boolean(metric.selectable),
                optgroup: RivalIQ.metric.search.getPropertyValue(sourceMetric, 'collection'),
                metric: metric,
                type: RivalIQ.metric.search.getPropertyValue(metric, 'type')
            };
        });

        return metricMap;
    };

    const collection = RivalIQ.enums.collection;
    metrics.getMetricGroups = function () {
        return [
            {
                value: collection.AUDIENCE,
                label: 'Audience'
            },
            {
                value: collection.ACTIVITY,
                label: 'Activity'
            },
            {
                value: collection.REACH,
                label: 'Reach'
            },
            {
                value: collection.IMPRESSIONS,
                label: 'Impressions'
            },
            {
                value: collection.ENGAGEMENT,
                label: 'Engagements'
            },
            {
                value: collection.ENGAGEMENT_DETAILS,
                label: 'Engagement Details'
            },
            {
                value: collection.STORY_ENGAGEMENTS,
                label: 'Story Engagements'
            },
            {
                value: collection.VIDEO_VIEWS_DETAILS,
                label: 'Video View Details'
            },
            {
                value: collection.REEL_DETAILS,
                label: 'Reel Details'
            },
            {
                value: collection.REELS_AND_VIDEOS,
                label: 'Reels and Videos'
            },
            {
                value: collection.PRESENCE_INTERACTIONS,
                label: 'Presence Interactions'
            },
            {
                value: collection.ORGANIC,
                label: 'Organic'
            },
            {
                value: collection.ADWORDS,
                label: 'AdWords'
            },
            {
                value: collection.GENERAL,
                label: 'General'
            }
        ];
    };
});
